import { ComponentType, PropsWithChildren } from 'react';

import Loadable from '@townsquare/loadable';
import type { LoadableComponent } from '@townsquare/loadable/types';

import { SearchSidebarNavigationProps } from '../types';

export const SearchSidebarNavigation: ComponentType<
	PropsWithChildren<SearchSidebarNavigationProps>
> &
	LoadableComponent = Loadable({
	loader: () =>
		import(/* webpackChunkName: "search-sidebar-navigation" */ './SearchSidebarNavigation'),
	loading: () => null,
});
